import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of, Subject } from "rxjs";
import { AgencyRightsProperties } from "../Models/AgencyRightsProperties";
import { AgencyService } from "../Services/Agency.service";

declare var $;

@Component({
  selector: 'app-agency-rights',
  templateUrl: './agency-rights.component.html',
  styleUrls: ['./agency-rights.component.css']
})
/** AgencyRights component*/
export class AgencyRightsComponent {
  /** AgencyRights ctor */
  constructor(private agencyService: AgencyService, private router: Router) { }

  agencyObj = new AgencyRightsProperties();

  ngOnInit() {
    this.LoadAgencyRights();
  }

  LoadAgencyRights() {
    try {
      let agencyId = "";
      if ((localStorage.getItem("AgencyIdRights") != undefined) && (localStorage.getItem("AgencyIdRights") != "")) {

        agencyId = (localStorage.getItem("AgencyIdRights"));
        this.agencyService.GetAgencyRightsById(agencyId).subscribe((data) => {
          if (data != undefined && data != null) {
            this.agencyObj = data;
            if (this.agencyObj.agencyId == null || this.agencyObj.agencyId == "")
              this.agencyObj.agencyId = agencyId
            localStorage.removeItem("AgencyIdRights");
          }
        })


      }
    }
    catch (e) {
    }

  }

  AdminCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.profileUpdate = true;
        this.agencyObj.beneficiaryAccount = true;
        this.agencyObj.paymentProcess = true;
        this.agencyObj.creditLimit = true;
        this.agencyObj.notifications = true;
        this.agencyObj.revenueManagement = true;
        this.agencyObj.offlineRequest = true;
        this.agencyObj.offlineSettings = true;
        this.agencyObj.supplierManagement = true;
        this.agencyObj.accountManagement = true;
        this.agencyObj.bookings = true;
        this.agencyObj.cms = true;
      }
      else {
        this.agencyObj.profileUpdate = false;
        this.agencyObj.beneficiaryAccount = false;
        this.agencyObj.paymentProcess = false;
        this.agencyObj.creditLimit = false;
        this.agencyObj.notifications = false;
        this.agencyObj.revenueManagement = false;
        this.agencyObj.offlineRequest = false;
        this.agencyObj.offlineSettings = false;
        this.agencyObj.supplierManagement = false;
        this.agencyObj.accountManagement = false;
        this.agencyObj.bookings = false;
        this.agencyObj.cms = false;
      }
    }
    catch (e) {
    }
  }
  PaymentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.addPayment = true;
        this.agencyObj.approvePayment = true;
        this.agencyObj.deletePayment = true;
      }
      else {
        this.agencyObj.addPayment = false;
        this.agencyObj.approvePayment = false;
        this.agencyObj.deletePayment = false;
      }
    }
    catch (e) {

    }
  }
  AccountCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.account = true;
        this.agencyObj.users = true;
        this.agencyObj.logs = true;
        this.agencyObj.currency = true;
      }
      else {
        this.agencyObj.account = false;
        this.agencyObj.users = false;
        this.agencyObj.logs = false;
        this.agencyObj.currency = false;
      }
    }
    catch (e) {

    }
  }
  BookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.agencyObj.searchBookings = true;
        this.agencyObj.viewBookings = true;
        this.agencyObj.updateBookings = true;
      }
      else {
        this.agencyObj.searchBookings = false;
        this.agencyObj.viewBookings = false;
        this.agencyObj.updateBookings = false;
      }
    }
    catch (e) {

    }
  }

  SaveRights() {
    try {
      if (this.agencyObj.paymentProcess == false) {
        this.agencyObj.addPayment = false;
        this.agencyObj.approvePayment = false;
        this.agencyObj.deletePayment = false;
      }
      if (this.agencyObj.accountManagement == false) {
        this.agencyObj.account = false;
        this.agencyObj.users = false;
        this.agencyObj.logs = false;
        this.agencyObj.currency = false;
      }
      if (this.agencyObj.bookings == false) {
        this.agencyObj.searchBookings = false;
        this.agencyObj.viewBookings = false;
        this.agencyObj.updateBookings = false;

      }

      if (this.agencyObj.agencyId != "" && this.agencyObj.agencyId != undefined) {
        if (this.agencyObj.agencyRightId != null && this.agencyObj.agencyRightId != 0
          && this.agencyObj.agencyRightId != undefined) {
          this.agencyService.UpdateAgencyRights(this.agencyObj).subscribe((data) => {
            if (data.isSave == true) {
              this.router.navigateByUrl("/agencyList")
            }
            else {
              $("#lblerrormsg").show();
              document.getElementById("lblerrormsg").innerHTML = "Something went wrong"
              $("#lblerrormsg").delay(5000).hide(10);
              return false;
            }
          })
        }
        else {
          this.agencyService.CreateAgencyRights(this.agencyObj).subscribe((data) => {
            if (data.isSave == true) {
              this.router.navigateByUrl("/agencyList")
            }
            else {
              $("#lblerrormsg").show();
              document.getElementById("lblerrormsg").innerHTML = "Something went wrong"
              $("#lblerrormsg").delay(5000).hide(10);
              return false;
            }
          });
        }
      }

    }
    catch (e) {

    }
  }
}
